import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=96e11464&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e11464')) {
      api.createRecord('96e11464', component.options)
    } else {
      api.reload('96e11464', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=96e11464&", function () {
      api.rerender('96e11464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iNiHnDNMJAaC/JS/comp/ImgFallback2.vue"
export default component.exports